import classes from './CustomLoadingOverlay.module.scss';
import { LazyLottie } from '../LazyLottie';

const importPageLoader = () => import('./resources/page-loader.json');

type CustomLoadingOverlayProps = {
  visible?: boolean;
  dataTestId?: string;
};

export function CustomLoadingOverlay({ visible = true }: CustomLoadingOverlayProps) {
  return (
    visible && (
      <div className={classes.overlayStyles} data-testid="overlay-loader">
        <div className={classes.loaderStyles}>
          <LazyLottie importFn={importPageLoader} autoplay loop />
        </div>
      </div>
    )
  );
}
